module.exports = __webpack_public_path__ + "img/c2.2371bf48.png";